import produce from "immer";
import { commonActions } from ".";
import { IStoreState } from "../initialStoreState";
import { defaultCommonState } from "./common.types";
import {
  CLEAR_GENERAL_HISTORY_STATE,
  CLEAR_RECORD_COUNTS,
  CLEAR_RECORD_COUNTS_V2,
  FETCH_GENERAL_HISTORY_LIST_FAILED,
  FETCH_GENERAL_HISTORY_LIST_PROGRESS,
  FETCH_GENERAL_HISTORY_LIST_SUCCESS,
  FETCH_MODULES_LIST_FAILED,
  FETCH_MODULES_LIST_PROGRESS,
  FETCH_MODULES_LIST_SUCCESS,
  FETCH_POLCIES_FAILED,
  FETCH_POLICIES_PROGRESS,
  FETCH_POLICIES_SUCCESS,
  FETCH_RECORD_COUNTS_FAILED,
  FETCH_RECORD_COUNTS_PROGRESS,
  FETCH_RECORD_COUNTS_SUCCESS,
  FETCH_RECORD_COUNTS_SUCCESS_V2,
  FETCH_RECORD_COUNTS_FAILED_V2,
  FETCH_RECORD_COUNTS_PROGRESS_V2,
  FETCH_FAULT_TYPE_PROGRESS,
  FETCH_FAULT_TYPE_SUCCESS,
  FETCH_FAULT_TYPE_FAILED,
  FETCH_FAULT_NAME_PROGRESS,
  FETCH_FAULT_NAME_SUCCESS,
  FETCH_FAULT_NAME_FAILED,
  FETCH_FAULT_SUB_TYPE_PROGRESS,
  FETCH_FAULT_SUB_TYPE_SUCCESS,
  FETCH_FAULT_SUB_TYPE_FAILED,
} from "./commonActions";
import { LoadState } from "../../constants/enums";
import { FETCH_REPORTEE_REFERRALS_FAILURE, FETCH_REPORTEE_REFERRALS_PROGRESS, FETCH_REPORTEE_REFERRALS_SUCCESS } from "../../constants/constants";

export const commonReducer = (
  state: IStoreState["common"] = defaultCommonState,
  action: commonActions
) => {
  switch (action.type) {
    case FETCH_POLICIES_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.policies.loadState = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_POLICIES_SUCCESS: {
      const { policies } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.policies.loadState = LoadState.Loaded;
        draftState.policies.list = policies;
      });
      return newState;
    }
    case FETCH_POLCIES_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.policies.loadState = LoadState.Failed;
        draftState.policies.list = [];
      });
      return newState;
    }

    case FETCH_GENERAL_HISTORY_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.generalHistory.loading = LoadState.InProgress;
        draftState.generalHistory.list = [];
      });
      return newState;
    }
    case FETCH_GENERAL_HISTORY_LIST_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.generalHistory.loading = LoadState.Loaded;
        draftState.generalHistory.list = data;
      });
      return newState;
    }
    case FETCH_GENERAL_HISTORY_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.generalHistory.loading = LoadState.Failed;
        draftState.generalHistory.list = [];
      });
      return newState;
    }
    case CLEAR_GENERAL_HISTORY_STATE: {
      const newState = produce(state, (draftState) => {
        draftState.generalHistory = defaultCommonState["generalHistory"];
      });
      return newState;
    }

    case FETCH_RECORD_COUNTS_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.recordCounts.loading = LoadState.InProgress;
        draftState.recordCounts.list = [];
      });
      return newState;
    }
    case FETCH_RECORD_COUNTS_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.recordCounts.loading = LoadState.Loaded;
        draftState.recordCounts.list = data;
      });
      return newState;
    }
    case FETCH_RECORD_COUNTS_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.recordCounts.loading = LoadState.Failed;
        draftState.recordCounts.list = [];
      });
      return newState;
    }
    
    case CLEAR_RECORD_COUNTS: {
      const newState = produce(state, (draftState) => {
        draftState.recordCounts = defaultCommonState["recordCounts"];
      });
      return newState;
    }
    case FETCH_RECORD_COUNTS_PROGRESS_V2: {
      const newState = produce(state, (draftState) => {
        draftState.recordCountsV2.loading = LoadState.InProgress;
        draftState.recordCountsV2.list = [];
      });
      return newState;
    }
    case FETCH_RECORD_COUNTS_SUCCESS_V2: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.recordCountsV2.loading = LoadState.Loaded;
        draftState.recordCountsV2.list = data;
      });
      return newState;
    }
    case FETCH_RECORD_COUNTS_FAILED_V2: {
      const newState = produce(state, (draftState) => {
        draftState.recordCountsV2.loading = LoadState.Failed;
        draftState.recordCountsV2.list = [];
      });
      return newState;
    }
    case CLEAR_RECORD_COUNTS_V2: {
      const newState = produce(state, (draftState) => {
        draftState.recordCountsV2 = defaultCommonState["recordCountsV2"];
      });
      return newState;
    }
    case FETCH_MODULES_LIST_PROGRESS: {
      const {isView} = action.payload;
      const newState = produce(state, (draftState) => {
        if(isView){
          draftState.modules.tableViews = {
            data: [], 
            loading: LoadState.InProgress,
          }
        }
        else {
          draftState.modules.tableNames = {
            data: [], 
            loading: LoadState.InProgress,
          }
        }
     
      });
      return newState;
    }
    case FETCH_MODULES_LIST_SUCCESS: {
      const {isView, data} = action.payload;
      const newState = produce(state, (draftState) => {
        if(isView){
          draftState.modules.tableViews = {
            data: data,
            loading: LoadState.Loaded,
          }
        }
        else {
          draftState.modules.tableNames = {
            data: data,
            loading: LoadState.Loaded,
          }
        }
     
      });
      return newState;
    }
    case FETCH_MODULES_LIST_FAILED: {
      const {isView} = action.payload;
      const newState = produce(state, (draftState) => {
        if(isView){
          draftState.modules.tableViews = {
            data: [], 
            loading: LoadState.Failed,
          }
        }
        else {
          draftState.modules.tableNames = {
            data: [], 
            loading: LoadState.Failed,
          }
        }
     
      });
      return newState;
    }

    case FETCH_REPORTEE_REFERRALS_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.reportee_referrals.loadState = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_REPORTEE_REFERRALS_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.reportee_referrals.list = data;
        draftState.reportee_referrals.loadState = LoadState.Loaded;
      });
      return newState;
    }
    case FETCH_REPORTEE_REFERRALS_FAILURE: {
      const newState = produce(state, (draftState) => {
        draftState.reportee_referrals.loadState = LoadState.Failed;
      });
      return newState;
    }

    case FETCH_FAULT_TYPE_PROGRESS: {
      const newState = produce(state, (draftState) => {
        if (!draftState.faultType) {
          draftState.faultType = { list: {}, loadState: LoadState.InProgress };
        } else {
          draftState.faultType.loadState = LoadState.InProgress;
        }
      });
      return newState;
    }
    case FETCH_FAULT_TYPE_SUCCESS: {
      const { vehicleType, list } = action.payload;
      const newState = produce(state, (draftState) => {
        if (!draftState.faultType) {
          draftState.faultType = { list: {}, loadState: LoadState.Loaded };
        }
        draftState.faultType.loadState = LoadState.Loaded;
        draftState.faultType.list[vehicleType] = list;
      });
      return newState;
    }
    case FETCH_FAULT_TYPE_FAILED: {
      const newState = produce(state, (draftState) => {
        if (!draftState.faultType) {
          draftState.faultType = { list: {}, loadState: LoadState.Failed };
        } else {
          draftState.faultType.loadState = LoadState.Failed;
        }
      });
      return newState;
    }

    case FETCH_FAULT_NAME_PROGRESS: {
      const newState = produce(state, (draftState) => {
        if (!draftState.faultName) {
          draftState.faultName = { list: {}, loadState: LoadState.InProgress };
        } else {
          draftState.faultName.loadState = LoadState.InProgress;
        }
      });
      return newState;
    }
    case FETCH_FAULT_NAME_SUCCESS: {
      const { key, list } = action.payload;
      const newState = produce(state, (draftState) => {
        if (!draftState.faultName) {
          draftState.faultName = { list: {}, loadState: LoadState.Loaded };
        }
        draftState.faultName.loadState = LoadState.Loaded;
        draftState.faultName.list[key] = list;
      });
      return newState;
    }
    case FETCH_FAULT_NAME_FAILED: {
      const newState = produce(state, (draftState) => {
        if (!draftState.faultName) {
          draftState.faultName = { list: {}, loadState: LoadState.Failed };
        } else {
          draftState.faultName.loadState = LoadState.Failed;
        }
      });
      return newState;
    }

    case FETCH_FAULT_SUB_TYPE_PROGRESS: {
      const newState = produce(state, (draftState) => {
        if (!draftState.subFaultName) {
          draftState.subFaultName = { list: {}, loadState: LoadState.InProgress };
        } else {
          draftState.subFaultName.loadState = LoadState.InProgress;
        }
      });
      return newState;
    }
    case FETCH_FAULT_SUB_TYPE_SUCCESS: {
      const { key, list } = action.payload;
      const newState = produce(state, (draftState) => {
        if (!draftState.subFaultName) {
          draftState.subFaultName = { list: {}, loadState: LoadState.Loaded };
        }
        draftState.subFaultName.loadState = LoadState.Loaded;
        draftState.subFaultName.list[key] = list;
      });
      return newState;
    }
    case FETCH_FAULT_SUB_TYPE_FAILED: {
      const newState = produce(state, (draftState) => {
        if (!draftState.subFaultName) {
          draftState.subFaultName = { list: {}, loadState: LoadState.Failed };
        } else {
          draftState.subFaultName.loadState = LoadState.Failed;
        }
      });
      return newState;
    }

    default: {
      return state;
    }
  }
};
